export const SET_DATA = "CREATE-NEW-CONTRACT/SET_DATA";
export const RESET_DATA = "CREATE-NEW-CONTRACT/RESET_DATA";
export const UPLOADS_LIST_ADD = "CREATE-NEW-CONTRACT/UPLOADS_LIST_ADD";
export const UPLOADS_LIST_REMOVE = "CREATE-NEW-CONTRACT/UPLOADS_LIST_REMOVE";
